var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllProductStatistic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1043_233955)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 16,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#11A2F1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 27C61.6475 27 62.7542 27.1465 63.8203 27.4395C64.8864 27.7324 65.8792 28.1556 66.7988 28.709C67.7184 29.2624 68.5607 29.9134 69.3257 30.6621C70.0907 31.4108 70.7458 32.2531 71.291 33.189C71.8363 34.1248 72.2554 35.1217 72.5483 36.1797C72.8413 37.2376 72.9919 38.3444 73 39.5C73 40.6475 72.8535 41.7542 72.5605 42.8203C72.2676 43.8864 71.8444 44.8792 71.291 45.7988C70.7376 46.7184 70.0866 47.5607 69.3379 48.3257C68.5892 49.0907 67.7469 49.7458 66.811 50.291C65.8752 50.8363 64.8783 51.2554 63.8203 51.5483C62.7624 51.8413 61.6556 51.9919 60.5 52C59.3525 52 58.2458 51.8535 57.1797 51.5605C56.1136 51.2676 55.1208 50.8444 54.2012 50.291C53.2816 49.7376 52.4393 49.0866 51.6743 48.3379C50.9093 47.5892 50.2542 46.7469 49.709 45.811C49.1637 44.8752 48.7446 43.8783 48.4517 42.8203C48.1587 41.7624 48.0081 40.6556 48 39.5C48 38.3525 48.1465 37.2458 48.4395 36.1797C48.7324 35.1136 49.1556 34.1208 49.709 33.2012C50.2624 32.2816 50.9134 31.4393 51.6621 30.6743C52.4108 29.9093 53.2531 29.2542 54.189 28.709C55.1248 28.1637 56.1217 27.7446 57.1797 27.4517C58.2376 27.1587 59.3444 27.0081 60.5 27ZM67.8608 35.3618L66.2007 33.7017L58.1562 41.7461L54.7993 38.3892L53.1392 40.0493L58.1562 45.0664L67.8608 35.3618Z",
    fill: "#C1E7FB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1043_233955",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1043_233955"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1043_233955"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1043_233955",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllProductStatistic);
export default __webpack_public_path__ + "static/media/all_product_statistic.ade82282ecfdaad3d6315b10de735cf0.svg";
export { ForwardRef as ReactComponent };